module.exports = __webpack_public_path__ + "img/alentour24.83fe09db.jpg";